import React from 'react';
import { AnimatePresence } from 'framer-motion';

const AnimateWrapper = ({ children }) => {
    return <AnimatePresence mode="wait">{children}</AnimatePresence>;
};

export default AnimateWrapper;
